const normalizeSinglesQuery = (value) => {
  const terms = value
    .trim()
    .split(/\s+/)
    .map((term) => term.replace(/[^\p{L}\p{N}\/.'+-]/gu, ''))
    .filter((term) => term && !/^(and|or|not)$/i.test(term));

  return terms.length ? `Singles AND ${terms.join(' AND ')}` : '';
};

document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('[data-aniware-singles-search]')) return;

  const input = form.querySelector('[data-aniware-singles-search-input]');
  if (!(input instanceof HTMLInputElement)) return;

  const query = normalizeSinglesQuery(input.value);
  if (!query) {
    event.preventDefault();
    input.focus();
    return;
  }

  input.value = query;
});
